import { render, staticRenderFns } from "./Estado.vue?vue&type=template&id=755dac98&"
import script from "./Estado.vue?vue&type=script&lang=js&"
export * from "./Estado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports